module.exports = __webpack_public_path__ + "static/media/one-on-one-tick.baa49793.svg";